var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : _vm.href ? 'a' : 'button',{tag:"component",class:[
    ("size-" + _vm.size),
    ("type-" + _vm.type),
    {
      'variant-block': _vm.block,
      'variant-rounded': _vm.rounded,
      'variant-fixed': _vm.fixed,
      'variant-inversed': _vm.inversed,
      loading: _vm.isLoading,
    } ],attrs:{"to":_vm.to ? _vm.to : undefined,"href":_vm.href ? _vm.href : undefined,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.iconBefore && !_vm.isLoading)?_c('Icon',{staticClass:"mr-1",attrs:{"name":_vm.iconBefore}}):_vm._e(),(!_vm.isLoading)?_vm._t("default"):_vm._e(),(_vm.isLoading)?_vm._t("loading"):_vm._e(),(_vm.iconAfter && !_vm.isLoading)?_c('Icon',{staticClass:"ml-1",attrs:{"name":_vm.iconAfter}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }